import { createFileRoute } from '@tanstack/react-router'

import PageSettings from '@/pages/PageSettings'

export const Route = createFileRoute('/settings/')({
  component: PageSettings
})
